// checkit.health — dedicated API client (separate token namespace from iAriya).
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const CK_TOKEN_KEY = 'checkit_token';
export const CK_USER_KEY = 'checkit_user';

export const ckApi = axios.create({ baseURL: API, timeout: 30000 });

ckApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(CK_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ---- Auth: checkit.health end-user flow (email confirmation on signup + OTP on every login) ----
export const ckRegister = (payload) => ckApi.post('/checkit/auth/register', payload);
export const ckVerifyEmail = (challenge, code) => ckApi.post('/checkit/auth/verify-email', { challenge, code });
export const ckLoginStart = (payload) => ckApi.post('/checkit/auth/login/start', payload);
export const ckLoginVerify = (challenge, code) => ckApi.post('/checkit/auth/login/verify', { challenge, code });
export const ckResendCode = (challenge) => ckApi.post('/checkit/auth/resend', { challenge });
// Google sign-in skips OTP (Google already verifies identity).
export const ckGoogleExchange = (session_id) => ckApi.post('/auth/oauth/google/exchange', { session_id, product: 'checkit' });

// ---- checkit product ----
export const ckGetConfig = () => ckApi.get('/checkit/config');
export const ckGetSite = () => ckApi.get('/checkit/site');
export const ckContact = (payload) => ckApi.post('/checkit/contact', payload);
export const ckGetMe = () => ckApi.get('/checkit/me');
export const ckUpdateEmailPrefs = (prefs) => ckApi.put('/checkit/me/email-prefs', prefs);
export const ckActivityPing = () => ckApi.post('/checkit/me/activity', {});
export const ckGetSummary = () => ckApi.get('/checkit/me/summary');
export const ckGetReferral = () => ckApi.get('/checkit/me/referral');
export const ckReferralInvite = (emails) => ckApi.post('/checkit/me/referral/invite', { emails });
export const ckShareCard = () => ckApi.get('/checkit/me/share-card.png', { responseType: 'blob' });
export const ckCheckout = (payload) => ckApi.post('/checkit/billing/checkout', payload);
export const ckBundle = (currency = 'USD', country = null) => ckApi.post('/checkit/billing/bundle', { currency, country });
export const ckVerify = (txRef) => ckApi.get(`/checkit/billing/verify/${txRef}`);
export const ckAi = (payload) => ckApi.post('/checkit/ai', payload, { timeout: 120000 });

// ---- Children's Health Centre ----
export const ckGrowthAssess = (payload) => ckApi.post('/checkit/growth/assess', payload);
export const ckGrowthCurves = (params) => ckApi.get('/checkit/growth/curves', { params });
export const ckGrowthStandards = () => ckApi.get('/checkit/growth/standards');
export const ckAddon = (addon = 'children', currency = 'USD', country = null) =>
  ckApi.post('/checkit/billing/addon', { addon, currency, country });

// ---- Children's Health Centre: cloud passport backup ----
export const ckKidsBackupGet = () => ckApi.get('/checkit/kids');
export const ckKidsBackupPut = (children, standard) => ckApi.put('/checkit/kids', { children, standard });
export const ckKidsBackupDelete = () => ckApi.delete('/checkit/kids');

// ---- Children's Health Centre: family sharing ----
export const ckKidShare = (child_id) => ckApi.post('/checkit/kids/share', { child_id });
export const ckKidShares = () => ckApi.get('/checkit/kids/shares');
export const ckKidShareRevoke = (id) => ckApi.delete(`/checkit/kids/share/${id}`);
export const ckKidSharedAccept = (code) => ckApi.post('/checkit/kids/shared/accept', { code });
export const ckKidShared = () => ckApi.get('/checkit/kids/shared');
export const ckKidSharedRemove = (id) => ckApi.delete(`/checkit/kids/shared/${id}`);
